<template>
  <div>
    <b-modal v-model="modal" ok-variant="danger" ok-title="Potwierdź" cancel-title="Anuluj" button-size="sm" @hidden="$emit('cancel')" @ok="$emit('ok')" hide-header>
      <slot name="body"></slot>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    confirmModal: Boolean
  },
  data() {
    return {
      modal: false
    };
  },
  beforeMount() {
    this.modal = this.confirmModal;
  }
};
</script>
